module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/plan02_point-7a6a914df686d25892a84cada06a6157.jpg";